import HeadComponent from "@js/components/Head";
import EducationModuleComplete from "@js/components/EducationModuleComplete";
import {
    getBadgeTokenId,
    getLessonCountFromModule,
    getModuleFromConfig,
    isModuleComplete,
} from "@js/util/educationUtil";
import Breadcrumb from "@js/components/Breadcrumb";
import { EducationModulePageProps } from "@js/components/EducationModule/types";
import { getAddressFromHeaders } from "@js/util/cookieUtil";
import { getAllCourseProgress } from "@js/prisma/prisma";

const props: EducationModulePageProps = {
    courseName: "N/A",
    moduleInfo: {
        title: "N/A",
        moduleName: "N/A",
        description: "N/A",
        id: -1,
        moduleComplete: {
            badgeName: "",
            badgeCaption: "",
            ribbonImgSrc: "",
            badgeImgSrc: "",
            imgColor: "",
        },
    },

    lessons: [],
    badgeTokenId: -1,
};

const defaultProps: any = {
    props: props,
};

export async function getServerSideProps(context: any) {
    // resolved url is the requested page (ex. /module/123)
    let path = context.resolvedUrl;
    try {
        // get moduleId and lesson id, can parse int because if they are not numbers we should go to the catch case -> id's should be numbers
        const splitAtModule = path.split("/module/")[1];
        const moduleId = parseInt(splitAtModule.split("/")[0]);
        //get courseName, this is a string
        const splitAtCourse = path.split("/course/")[1];
        const courseName = splitAtCourse.split("/")[0];
        const module = getModuleFromConfig(courseName, moduleId);
        if (!module) {
            return defaultProps;
        }

        const address = getAddressFromHeaders(context.req.headers);
        const allCourseProgress = await getAllCourseProgress(address);
        const badgeTokenId = getBadgeTokenId(courseName, moduleId);

        return {
            props: {
                courseName: courseName,
                moduleInfo: module.moduleInfo,
                lessons: module.lessons,
                allCourseProgress,
                badgeTokenId,
            },
        };
    } catch (e) {
        console.error(e);
        return defaultProps;
    }
}

const EducationModuleCompletePage = (props: EducationModulePageProps) => {
    const moduleTitle = props.moduleInfo.title;
    let educationTitle = `Module: ${moduleTitle} Complete`;

    const courseName = props.courseName;
    const moduleId = props.moduleInfo.id;
    const numLessons = getLessonCountFromModule(courseName, moduleId);
    if (
        !isModuleComplete(
            props.allCourseProgress,
            courseName,
            moduleId,
            numLessons
        )
    ) {
        return (
            <>
                <Breadcrumb />
                <div>You do not have access</div>
            </>
        );
    }
    return (
        <>
            <Breadcrumb />
            <HeadComponent title={educationTitle} />
            <EducationModuleComplete {...props} />
        </>
    );
};

export default EducationModuleCompletePage;
